import type { MovieReview } from '@/types/movie';

interface ReviewListProps {
  reviews: MovieReview[];
}

export default function ReviewList({ reviews }: ReviewListProps) {
  return (
    <div className="space-y-4">
      {reviews.map((review, index) => (
        <article key={index} className="rounded-xl border border-background-200 bg-background-50 p-4">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-sm font-bold text-primary-700">
                {review.author.slice(0, 1)}
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-900">{review.author}</p>
                <p className="flex items-center gap-0.5 text-xs text-secondary-600">
                  {Array.from({ length: 5 }).map((_, starIndex) => (
                    <i
                      key={starIndex}
                      className={starIndex < Math.round(review.rating / 2) ? 'ri-star-fill' : 'ri-star-line'}
                    ></i>
                  ))}
                </p>
              </div>
            </div>
            <span className="whitespace-nowrap rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-bold text-secondary-900">
              {review.rating.toFixed(1)} 分
            </span>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">{review.content}</p>
        </article>
      ))}
    </div>
  );
}